const accessRight = { none: 0, read: 1, edit: 3, full: 7,}

export { accessRight }
